import { useSanitizedHtml } from "@/shared/hooks/useSanitizedHtml";

type SerializeHTMLProps = {
  htmlContent: string
  className?: string
  allowedTags?: string[]
  allowedAttributes?: string[]
};

export const SerializeHTML = ({
  htmlContent,
  className = "",
  allowedTags,
  allowedAttributes,
}: SerializeHTMLProps) => {
  const sanitizedHtml = useSanitizedHtml(htmlContent, { allowedTags, allowedAttributes });

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
